import moment from 'moment/moment'

export class Util {
  static illuminanceValueFilter (plugReportValue) {
    const values = []

    for (var i = 0; i < plugReportValue.length; i++) {
      if ((i + 1) % 7 !== 0) {
        values.push(plugReportValue[i])
      }
    }

    return values
  }

  static Plug = class {
    static isOnline (plug, status) {
      if (plug) {
        if (typeof status === 'undefined') {
          status = plug.status
        }

        if (status) {
          const duration = moment.duration(moment().diff(status.updated.toDate()))
          const diffMinitues = duration.asMinutes()

          return status.online && (diffMinitues <= 60 + 5) // + 5 는 오차 범위
        } else {
          return false
        }
      } else {
        return false
      }
    }

    static isOnCharging (plug, status) {
      if (Util.Plug.isOnline(plug, status)) {
        if (typeof status === 'undefined') {
          status = plug.status
        }

        return status.oncharging
      } else {
        return false
      }
    }

    static parseValue (plugReportValue) {
      const r = {values: 0, duration: 0, wh: 0}

      r.values = Util.illuminanceValueFilter(plugReportValue)
      r.duration = r.values.length * 5
      r.wh = r.values.reduce((a, b) => {
        if (isNaN(a)) {
          a = 0
        }

        if (isNaN(b)) {
          b = 0
        }

        return a + b
      })

      return r
    }
  }

  /**
   * 전화번호 포멧
   *
   * @param {String} phoneNumber
   * @param {Boolean} hyphen
   * @param {Boolean} international
   */
  static phoneNumberFormat (phoneNumber, hyphen, international) {
    try {
      phoneNumber = phoneNumber
        .replace(/\D/g, '')
        .replace(/^82/, '0') // 나라코드 제거, 숫자를 제외한 값 제거

      const pattern = /^(01[016789])([1-9][0-9]{3})([0-9]{4})$/g
      const group = pattern.exec(phoneNumber)

      if (group) {
        if (international && hyphen) {
          return '+82-' + group[1].replace(/^0/, '') + '-' + group[2] + '-' + group[3]
        } else if (international && !hyphen) {
          return '+82' + group[1].replace(/^0/, '') + '' + group[2] + '' + group[3]
        } else if (!international && hyphen) {
          return group[1] + '-' + group[2] + '-' + group[3]
        } else { // if (!international && !hyphen)
          return group[1] + '' + group[2] + '' + group[3]
        }
      } else {
        return phoneNumber
      }
    } catch (error) {
      if (error) {
        console.log(error)
      }

      return phoneNumber
    }
  }

  static getReadableReportAddress (report) {
    if (report.kakaoAddress && report.kakaoAddress.documents && report.kakaoAddress.documents.length > 0) {
      if (report.kakaoAddress.documents[0].road_address) {
        return report.kakaoAddress.documents[0].road_address.address_name.replace('대한민국', '').replace('대전광역시', '').replace('대전', '').trim()
      } else {
        return report.kakaoAddress.documents[0].address.address_name.replace('대한민국', '').replace('대전광역시', '').replace('대전', '').trim()
      }
      // console.log(report.kakaoAddress.documents[0].road_address)
      // return report.kakaoAddress.documents[0].road_address.address_name
    } else if (report.address) {
      return report.address.replace('대한민국', '').replace('대전광역시', '').replace('대전', '').trim()
    } else if (report.location) {
      return report.location.latitude + ',' + report.location.longitude
    } else {
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Util.js